import { render, staticRenderFns } from "./PropostaAssinante.vue?vue&type=template&id=4fac5a02"
import script from "./PropostaAssinante.vue?vue&type=script&lang=js"
export * from "./PropostaAssinante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports